import consumer from "./consumer";

// Singleton subscription to NotificationsChannel
// This ensures only one subscription exists and can be shared across controllers
class NotificationsSubscription {
  private static instance: NotificationsSubscription | null = null;
  private subscription: any = null;
  private callbacks: Array<(data: any) => void> = [];

  private constructor() {
    this.createSubscription();
  }

  static getInstance(): NotificationsSubscription {
    if (!NotificationsSubscription.instance) {
      NotificationsSubscription.instance = new NotificationsSubscription();
    }
    return NotificationsSubscription.instance;
  }

  private createSubscription() {
    console.log("Creating shared NotificationsChannel subscription");
    this.subscription = consumer.subscriptions.create(
      { channel: "NotificationsChannel" },
      {
        received: (data: any): void => {
          console.log("Shared subscription received:", data);
          // Notify all registered callbacks
          this.callbacks.forEach((callback) => callback(data));
        },
      },
    );
  }

  // Register a callback to receive notifications
  addCallback(callback: (data: any) => void): void {
    this.callbacks.push(callback);
  }

  // Unregister a callback
  removeCallback(callback: (data: any) => void): void {
    this.callbacks = this.callbacks.filter((cb) => cb !== callback);
  }

  // Perform an action on the channel (e.g., typing)
  perform(action: string, data: any): void {
    if (this.subscription && this.subscription.perform) {
      this.subscription.perform(action, data);
    } else {
      console.error("Subscription not ready to perform action");
    }
  }
}

export default NotificationsSubscription;
